import stringHelpers from 'helpers/string';

const clientId = window.REACT_APP_IAM_CLIENT_ID;
const oauthDomain = window.REACT_APP_IAM_OAUTH_DOMAIN;

const { isJsonString } = stringHelpers;

/**
 * Check whether current app is in iframe or not
 */
const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

/**
 * Get data passed from container (staff interface) to iframe (current app)
 */
const getDataFromIframe = (): {
  localization?: string;
  parentOrigin?: string;
  clientId?: string;
  oauthDomain?: string;
} => {
  return isJsonString(window.name) ? JSON.parse(window.name) : {};
};

/**
 * Get client id within/without an iframe
 */
const getClientId = () => {
  const { clientId: iframeClientId } = getDataFromIframe();
  return inIframe() && iframeClientId ? iframeClientId : clientId;
};

/**
 * Get oauth domain within/without an iframe
 */
const getOAuthDomain = () => {
  const { oauthDomain: iframeOAuthDomain } = getDataFromIframe();
  return inIframe() && iframeOAuthDomain ? iframeOAuthDomain : oauthDomain;
};

export default {
  inIframe,
  getDataFromIframe,
  getClientId,
  getOAuthDomain,
};
